import { render, staticRenderFns } from "./SelectWrt.vue?vue&type=template&id=936fb680&"
import script from "./SelectWrt.vue?vue&type=script&lang=js&"
export * from "./SelectWrt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports